const valueOrFirstOrNull = <T>(input: T | T[] | undefined): T | null => {
	if (input === undefined) {
		return null;
	}

	if (Array.isArray(input)) {
		return input[0] ?? null;
	}

	return input;
};

export { valueOrFirstOrNull };
